// Marca de una máquina del Parque de Maquinaria — catálogo cerrado, orden alfabético
export const MarcaMaquinariaArray = [
  { id: "AGRINDSA", display: "AGRINDSA" },
  { id: "AMP SPRAYERS", display: "AMP SPRAYERS" },
  { id: "AZTECA", display: "AZTECA" },
  { id: "BERKELEY", display: "BERKELEY" },
  { id: "BISON", display: "BISON" },
  { id: "CaseIH", display: "CaseIH" },
  { id: "CESEÑA", display: "CESEÑA" },
  { id: "DJI", display: "DJI" },
  { id: "DURABLE", display: "DURABLE" },
  { id: "FAMAQ", display: "FAMAQ" },
  { id: "GASPARDO", display: "GASPARDO" },
  { id: "INTERNATIONAL", display: "INTERNATIONAL" },
  { id: "JACTO", display: "JACTO" },
  { id: "JOHN DEERE", display: "JOHN DEERE" },
  { id: "KELLY", display: "KELLY" },
  { id: "Kioti", display: "Kioti" },
  { id: "Kubota", display: "Kubota" },
  { id: "LOCAL", display: "LOCAL" },
  { id: "MASCHIO", display: "MASCHIO" },
  { id: "Massey Ferguson", display: "Massey Ferguson" },
  { id: "McCormick", display: "McCormick" },
  { id: "MONOSEM", display: "MONOSEM" },
  { id: "New Holland", display: "New Holland" },
  { id: "NOGUEIRA", display: "NOGUEIRA" },
  { id: "NUÑEZ", display: "NUÑEZ" },
  { id: "OSMAQ", display: "OSMAQ" },
  { id: "PERKINS", display: "PERKINS" },
  { id: "PONY", display: "PONY" },
  { id: "PROSEM", display: "PROSEM" },
  { id: "RAESA", display: "RAESA" },
  { id: "RILAZ", display: "RILAZ" },
  { id: "RIVULIS", display: "RIVULIS" },
  { id: "Same", display: "Same" },
  { id: "SOLANO", display: "SOLANO" },
  { id: "STHIL", display: "STHIL" },
  { id: "SWISSMEX", display: "SWISSMEX" },
  { id: "TERRAMAK", display: "TERRAMAK" },
  { id: "TORO", display: "TORO" },
  { id: "TRES ESTRELLAS", display: "TRES ESTRELLAS" },
  { id: "VAZQUEZ", display: "VAZQUEZ" },
  { id: "YUKON", display: "YUKON" },
];
